module.exports = __webpack_public_path__ + "static/media/banner_AESexy-half.a5282bd5.png";